import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "География. 10 класс.",
        subject: "Топливно-энергетический комплекс мира",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Топливно-энергетический комплекс мира",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Барабанов Вадим Владимирович",
                grade: "научный сотрудник лаборатории социально-гуманитарного общего образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.jpg"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>" +
                                "<p>В методическом кейсе рассматривается методика формирования понятий «энергетический переход», «сланцевая революция», «водородная» энергетика» при изучении темы «Топливно-энергетический комплекс мира». </p>" +
                                "<p>Планируемые предметные результаты освоения содержания этой темы предусматривают формирование умения применять понятия для решения учебных практико-ориентированных задач. В действующих УМК пока нет таких примеров и не разработана методика проведения предусмотренной программой практической работы «Представление в виде диаграмм данных о динамике изменения объёмов и структуры производства электроэнергии в мире».</p>" +
                                "<p>В данном кейсе освещаются подходы к введению и отработке новых понятий, описаны виды деятельности обучающихся, которые целесообразно предусмотреть при изучении темы. Приведены примеры заданий, которые целесообразно использовать при оценке достижения обучающимися планируемых результатов освоения темы.</p>" +
                                "<p>Учитель получит рекомендации по организации и проведению практической работы по теме, получит ответы на то, какие раздаточные материалы использовать.</p>" +
                                "</div>"
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4"
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Козеняшева М.М., Мингалеева Р.Д. Понятие «энергопереход» на современном этапе трансформации мировой экономики // Экономические науки. – 2022. – № 12",
                "Митрова Т. А. Энергопереход и риски для России // Нефтегазовая вертикаль. – 2021. – № 6",
                "Климшина Т. В. Сланцевая революция и её последствия для мирового энергетического рынка // Образовательный портал «Справочник». – Дата последнего обновления статьи: 14.01.2023, [Электронный ресурс]",
                "Что такое «зелёный водород» и какой водород бывает вообще? // Электротехнический журнал. – 2021, [Электронный ресурс]",
                "Об утверждении Концепции развития водородной энергетики в Российской Федерации от 05 августа 2021, [Электронный ресурс]"
            ],
            filesToDownload: [
                {
                    link: "./files/geography.pdf",
                    fileName: "Схема энергоперехода"
                },
                {
                    link: "./files/task.pdf",
                    fileName: "Задание на применение понятия «водородная энергетика»"
                }
            ]
        }
    ],
};
